import { Controller } from "@hotwired/stimulus"

// Manages dynamic select-option inputs for custom application questions.
// Supports adding, removing, and drag-and-drop reordering of options.
//
// Usage:
// <div data-controller="question-options"
//      data-question-options-name-value="form[response_options][]">
//   <div data-question-options-target="list"></div>
//   <template data-question-options-target="template">...</template>
// </div>
export default class extends Controller {
  static targets = ["list", "template"]
  static values = {
    name: String,
  }

  connect() {
    if (!this.hasNameValue) {
      this.nameValue = "form[response_options][]"
    }

    if (this.listTarget.children.length === 0) {
      this.add()
    }
  }

  add(event) {
    event?.preventDefault()
    const fragment = this.templateTarget.content.cloneNode(true)
    const inputEl = fragment.querySelector("[data-question-options-target='input']")

    if (inputEl) {
      inputEl.name = this.nameValue
    }

    this.listTarget.appendChild(fragment)
    inputEl?.focus()
  }

  remove(event) {
    event.preventDefault()
    const row = event.target.closest("[data-question-options-target='row']")
    row?.remove()

    if (this.listTarget.children.length === 0) {
      this.add()
    }
  }

  dragstart(event) {
    this.draggedRow = event.target.closest("[data-question-options-target='row']")
    if (!this.draggedRow) return

    this.draggedRow.classList.add("opacity-50")
    event.dataTransfer.effectAllowed = "move"
    event.dataTransfer.setData("text/plain", "")
  }

  dragover(event) {
    event.preventDefault()
    event.dataTransfer.dropEffect = "move"

    const targetRow = event.target.closest("[data-question-options-target='row']")
    if (!targetRow || targetRow === this.draggedRow) return

    const rect = targetRow.getBoundingClientRect()
    const midpoint = rect.top + rect.height / 2

    if (event.clientY < midpoint) {
      this.listTarget.insertBefore(this.draggedRow, targetRow)
    } else {
      this.listTarget.insertBefore(this.draggedRow, targetRow.nextSibling)
    }
  }

  dragend() {
    if (this.draggedRow) {
      this.draggedRow.classList.remove("opacity-50")
      this.draggedRow = null
    }
  }
}
